import { useEffect, useState } from "react"
import Base from "../layout/LandingPage"
import axiosInstance from "../axiosInstance"
import { Link } from "react-router-dom"
import img1 from "../gallery/1.jpg";
import img2 from "../gallery/2.jpg";
import img3 from "../gallery/3.jpg";
import img4 from "../gallery/4.jpg";
import img5 from "../gallery/5.jpg";
import img6 from "../gallery/6.jpg";
import img7 from "../gallery/7.jpg";
import img8 from "../gallery/8.jpg";
import img9 from "../gallery/9.jpg";
import img10 from "../gallery/10.jpg";
import img11 from "../gallery/11.jpg";
import img12 from "../gallery/12.jpg";
import img13 from "../gallery/13.jpg";
import img14 from "../gallery/14.jpg";
import img15 from "../gallery/15.jpg";
import img16 from "../gallery/16.jpg";
import img17 from "../gallery/17.jpg";

const Gallery = () => {

    const [data, setData] = useState("")

    useEffect(() => {
        // getData(1)
        //eslint-disable-next-line
    }, [])

    const images = [
        img3,
        img4,
        img5,
        img6,
        img16,
        img1,
        img7,
        img8,
        img9,
        img2,
        img13,
    ]

    const hut = [
        img14,
        img15,
        img10,
        img11,
        img12,

        img17,
    ]

    return (
        <Base>
            <div className="container">
                <h1 className="title">Rooms</h1>
                <div className="row gallery">
                    {
                        images?.map((res, id) => {
                            return (
                                <div className="col-12 col-md-4 wowload fadeInUp" key={id}>
                                    <a
                                        href="#"
                                        className="gallery-image"
                                        data-gallery=""
                                    >
                                        <img
                                            src={res}
                                            className="img-responsive"
                                        />
                                    </a>
                                </div>
                            )
                        })
                    }
                </div>
                <div className="text-center">
                    {/* <ul className="pagination">
                        <li onClick={() => getData(1)}>
                            <Link href="#">«</Link>
                        </li>
                        {
                            new Array(data?.page)?.fill("")?.map((res, id) => {
                                return (
                                    <li key={id} onClick={() => getData(id + 1)}>
                                        <Link to="#">{id + 1}</Link>
                                    </li>
                                )
                            })
                        }
                        <li onClick={() => getData(data?.page)}>
                            <Link href="#">»</Link>
                        </li>
                    </ul> */}
                </div>
                <h1 className="title">Hut House</h1>
                <div className="row gallery">
                    {
                        hut?.map((res, id) => {
                            return (
                                <div className="col-12 col-md-4 wowload fadeInUp" key={id}>
                                    <a
                                        href="#"
                                        className="gallery-image"
                                        data-gallery=""
                                    >
                                        <img
                                            src={res}
                                            className="img-responsive"
                                        />
                                    </a>
                                </div>
                            )
                        })
                    }
                </div>
            </div>

        </Base>
    )
}

export default Gallery